module.exports = __webpack_public_path__ + "static/img/10.d250149.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/10.png
// module id = 5xqn
// module chunks = 0